const shouldHighlightMonth = (date: Date) => {
  const now = new Date()

  if (date.getFullYear() !== now.getFullYear()) {
    return false
  }

  return (
    date.getMonth() > now.getMonth() && date.getMonth() <= now.getMonth() + 3
  )
}

const isCurrentMonth = (date: Date) => {
  const now = new Date()
  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth()
  )
}

export { shouldHighlightMonth, isCurrentMonth }
